<template>
	<footer class="footer">
		<div class="content">
			<ul class="about">
				<li>
					<router-link to="/about">关于</router-link>
				</li>
				<li>
					<router-link to="/agreements">隐私政策</router-link>
				</li>
				<li>
					<a :href="$store.state.serverConfig.owner_link">{{ $store.state.serverConfig.owner }}</a>
				</li>
			</ul>
			<div class="copyright">
				<span>{{ $store.state.serverConfig.copyright }}</span
				><br />
				<span>{{ $store.state.serverConfig.icp_number }}</span
				><br /><br />
				<span>{{ $store.state.serverConfig.technical_support }}</span>
			</div>
		</div>
	</footer>
</template>
<script>
export default {}
</script>
<style lang="scss">
@import '@/styles/settings.scss';
.footer {
	.content {
		width: $mainWidth - 15 * 2;
		margin: 0 auto;
	}
	font-size: 14px;
	padding: 12.5px 0;
	background: #242d35;
	color: #727c86;
	.about {
		overflow: hidden;
		li {
			float: left;
			border-left: 1px solid #727c86;
			padding: 0 20px;
			list-style-type: none;
			&:first-child {
				border-left: none;
				padding-left: 0;
			}
		}
	}
	.copyright {
		overflow: hidden;
		text-align: center;
		font-size: 12px;
	}
}
</style>
